import { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

// Date cible : 01.01.2028
const TARGET_DATE = new Date('2028-01-01T00:00:00');

export const FiscalCountdown = ({ compact = false }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date();
    const difference = TARGET_DATE - now;
    
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (timeLeft.expired) {
    return null;
  }

  if (compact) {
    return (
      <div className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm">
        <span className="text-orange-600 font-semibold">
          {timeLeft.days}j {timeLeft.hours}h {timeLeft.minutes}m
        </span>
        <span className="text-muted-foreground hidden sm:inline">restants</span>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-lg sm:rounded-xl p-4 sm:p-6" data-testid="fiscal-countdown">
      <div className="flex items-center gap-2 mb-2 sm:mb-3">
        <AlertTriangle className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
        <span className="font-semibold text-orange-800 text-xs sm:text-sm md:text-base">Fenêtre fiscale actuelle (estimation)</span>
      </div>
      
      <div className="flex justify-center gap-2 sm:gap-4 mb-3 sm:mb-4">
        <div className="text-center">
          <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600">{timeLeft.days}</div>
          <div className="text-[10px] sm:text-xs text-muted-foreground uppercase">Jours</div>
        </div>
        <div className="text-xl sm:text-2xl md:text-3xl font-light text-orange-400">:</div>
        <div className="text-center">
          <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600">{String(timeLeft.hours).padStart(2, '0')}</div>
          <div className="text-[10px] sm:text-xs text-muted-foreground uppercase">Heures</div>
        </div>
        <div className="text-xl sm:text-2xl md:text-3xl font-light text-orange-400">:</div>
        <div className="text-center">
          <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600">{String(timeLeft.minutes).padStart(2, '0')}</div>
          <div className="text-[10px] sm:text-xs text-muted-foreground uppercase">Minutes</div>
        </div>
        <div className="text-xl sm:text-2xl md:text-3xl font-light text-orange-400 hidden sm:block">:</div>
        <div className="text-center hidden sm:block">
          <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600">{String(timeLeft.seconds).padStart(2, '0')}</div>
          <div className="text-[10px] sm:text-xs text-muted-foreground uppercase">Secondes</div>
        </div>
      </div>
      
      <p className="text-center text-xs sm:text-sm text-orange-700 font-medium">
        Il vous reste une fenêtre pour optimiser vos travaux
      </p>
      
      <p className="text-center text-[10px] sm:text-xs text-muted-foreground mt-1.5 sm:mt-2 italic">
        Date indicative basée sur le calendrier fédéral et la mise en œuvre cantonale.
      </p>
    </div>
  );
};
